<div class="panel-backdrop" [class.is-visible]="isOpen" (click)="closePanel()"></div>

<div class="notification-modal" [class.is-open]="isOpen">
  <header class="panel-header">
    <h4>Notificações</h4>
    <button class="close-btn" (click)="closePanel()">&times;</button>
  </header>
  <div class="panel-body">
    <div *ngIf="notifications.length === 0 && !isLoading" class="empty-state">
      Nenhuma notificação encontrada.
    </div>

    <div *ngFor="let notification of notifications" class="notification-item">
      <div class="notification-content">
        <strong class="title">{{ notification.title }}</strong>

        <p class="message mb-1">{{ notification.message }}</p>

        <small class="date text-muted">
          {{ notification.creationTime | date:'dd/MM/yyyy HH:mm' }}
        </small>
      </div>

      <div class="notification-actions ms-auto">
        <button class="btn btn-sm btn-outline-danger" (click)="delete(notification.id)" title="Excluir notificação">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-spinner">
      Carregando...
    </div>

    <button *ngIf="!isLastPage && !isLoading && notifications.length > 0" class="btn btn-secondary w-100" (click)="loadNotifications(true)">
      Carregar Mais
    </button>
  </div>
</div>
